import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Select } from '@st-operations/uikit/src/v2'

import MonthPicker from './MonthPicker.jsx'

import './styles.scss'

export const TIME_PERIOD_VALUES = {
  MONTH_1: 1,
  MONTH_3: 3,
  MONTH_6: 6,
  YEAR_1: 12,
  CUSTOM: -1,
}

export function monthStrToDate(monthStr) {
  const split = monthStr.split('-')
  return new Date(Number.parseInt(split[0], 10), Number.parseInt(split[1], 10) - 1, 1)
}

export function getCurrentYearMonthString(monthInc = 0) {
  return `${new Date().getFullYear()}-${new Date().getMonth() + 1 + monthInc}`
}

export function currDayMonthToString(month) {
  return `${month.getFullYear()}-${((month.getMonth() + 1 || 12) + '').padStart(2, '0')}-${(
    new Date().getDate() + ''
  ).padStart(2, '0')}`
}

const PeriodSelect = ({
  style,
  selectClassName,
  minDate,
  monthFrom,
  monthTo,
  period,
  vertical,
  label = 'Time Period',
  onMonthFromChange = () => null,
  onMonthToChange = () => null,
  onPeriodChange,
  customOptions,
}) => {
  return (
    <div className={classNames('period-select', { 'period-select--vertical': vertical })}>
      <Select
        className={classNames('period-select__month-picker-container', selectClassName)}
        style={{ ...style, ...(vertical ? { width: '100%' } : { width: '50%' }) }}
        styles={{ menu: (baseStyles) => ({ ...baseStyles, zIndex: 9999999 }) }}
        label={label}
        options={
          customOptions || [
            { label: '1 month', value: TIME_PERIOD_VALUES.MONTH_1 },
            { label: '3 months', value: TIME_PERIOD_VALUES.MONTH_3 },
            { label: '6 months', value: TIME_PERIOD_VALUES.MONTH_6 },
            { label: '1 year', value: TIME_PERIOD_VALUES.YEAR_1 },
            { label: 'Custom', value: TIME_PERIOD_VALUES.CUSTOM },
          ]
        }
        value={period}
        onChange={({ value }) => onPeriodChange(value)}
        useReactSelect
      />
      <If condition={period === TIME_PERIOD_VALUES.CUSTOM}>
        <div
          className="period-select__custom-container"
          style={{
            marginLeft: 10,
            flexDirection: 'column',
          }}
        >
          <span className="date-period-period-selector__input-label">Range</span>
          <MonthPicker
            from={minDate}
            to={getCurrentYearMonthString()}
            startValue={monthFrom}
            endValue={monthTo}
            onChange={(start, end) => {
              onMonthFromChange(start)
              onMonthToChange(end)
            }}
            popupDirectionBottom
            beginByLastYear
          />
        </div>
      </If>
    </div>
  )
}

PeriodSelect.propTypes = {
  style: PropTypes.object,
  minDate: PropTypes.string.isRequired,
  monthFrom: PropTypes.string.isRequired,
  monthTo: PropTypes.string.isRequired,
  period: PropTypes.oneOf(Object.values(TIME_PERIOD_VALUES)).isRequired,
  vertical: PropTypes.bool,
  label: PropTypes.string,
  onMonthFromChange: PropTypes.func,
  onMonthToChange: PropTypes.func,
  onPeriodChange: PropTypes.func.isRequired,
  customOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
}

export default PeriodSelect
